module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_4250_Inactive@1x-d8eb761189918c75a54d33a9abf1a78e.png";